<template>
  <div class="contenedor-principal">
    <h1>Proyectos Natura</h1>
    <h2>Bio-Regeneración Comunitaria</h2>
    
    <h3>Revitalizando ecosistemas, conectando personas</h3>
    <p>En Geobizi, nos enfocamos en promover la sostenibilidad y el cuidado del medio ambiente a través de diversos proyectos de bio-regeneración y conservación natural. Estos proyectos están diseñados para fomentar la biodiversidad y la implicación activa de la comunidad.</p>
          <h2>Proyecto de Bio-regeneración</h2>
          <p>
            En respuesta a la creciente necesidad de iniciativas que promuevan la sostenibilidad y el cuidado del medio ambiente, presentamos una propuesta de proyecto para la bio-regeneración de la zona donde se encuentra el centro o entidad. 
            Este proyecto tiene como objetivo principal fomentar la biodiversidad, la regeneración natural y la implicación activa de la comunidad en la mejora del entorno local.
          </p>
    <h3>¿Por qué Bio-Regeneración?</h3>
    <p>
      <img src="/imagenes/iconos/color/estrellitas.png" alt="Icono acción — proyectos" title="Acción — proyecto biorregeneración" class="icono" loading="lazy" />
      <strong>Porque cada acción cuenta</strong> – Pequeños gestos pueden transformar un ecosistema.
    </p>
    <p>
      <img src="/imagenes/iconos/color/familia.png" alt="Icono comunidad — participación ciudadana" title="Comunidad — participación" class="icono" loading="lazy" />
      <strong>Porque la comunidad es clave</strong> – Juntos, logramos un impacto mayor.
    </p>
    <p>
      <img src="/imagenes/iconos/color/arbol.png" alt="Icono biodiversidad — especies autóctonas" title="Biodiversidad — especies autóctonas" class="icono" loading="lazy" />
      <strong>Porque la biodiversidad nos necesita</strong> – Recuperar especies autóctonas es esencial para el equilibrio natural.
    </p>

    <h3>Objetivos del Proyecto</h3>
    <ul>
      <li>
        <img src="/imagenes/iconos/color/hojas.png" alt="Icono hojas — biodiversidad" title="Biodiversidad — hojas" class="icono" loading="lazy" />
        <strong>Promover la biodiversidad</strong> – Recuperación de flora y fauna autóctonas.</li>
      <li>
        <img src="/imagenes/iconos/color/estrellitas.png" alt="Icono acción — intervención" title="Acción — intervención" class="icono" loading="lazy" />
        <strong>Regeneración natural asistida</strong> – Ayudar a que el ecosistema se recupere con técnicas sostenibles.</li>
      <li>
        <img src="/imagenes/iconos/color/adaptable.png" alt="Icono adaptable — formación" title="Educación ambiental — adaptable" class="icono" loading="lazy" />
        <strong>Educación ambiental activa</strong> – Talleres prácticos para todas las edades.</li>
      <li>
        <img src="/imagenes/iconos/color/manos.png" alt="Icono manos — colaboración" title="Colaboración — manos" class="icono" loading="lazy" />
        <strong>Crear redes comunitarias</strong> – Conectar vecinos, escuelas y empresas en un mismo propósito.</li>
    </ul>

    <h3>Actividades Clave</h3>
    <ul>
      <li>
        <img src="/imagenes/iconos/color/hojas.png" alt="Icono hojas — explosión de vida" title="Explosión de vida — semillas" class="icono" loading="lazy" />
        <strong>Explosión de Vida</strong> – Creación de bombas de semillas (nendo dango) para regenerar zonas degradadas de forma natural y divertida.</li>
      <li>
        <img src="/imagenes/iconos/color/mariposita.png" alt="Icono mariposa — oasis de polinizadores" title="Oasis de mariposas" class="icono" loading="lazy" />
        <strong>Oasis de Mariposas</strong> – Diseño de jardines polinizadores y refugios para mariposas, esenciales para la biodiversidad.</li>
      <li>
        <img src="/imagenes/iconos/color/abeja.png" alt="Icono abeja — casas de insectos" title="Casas de insectos — abejas" class="icono" loading="lazy" />
        <strong>Casas de Insectos</strong> – Talleres para construir hoteles de insectos, refugios para abejas solitarias y otros polinizadores.</li>
      <li>
        <img src="/imagenes/iconos/color/arbol.png" alt="Icono árbol — rutas guiadas" title="Rutas guiadas — naturaleza" class="icono" loading="lazy" />
        <strong>Conociendo Nuestro Entorno</strong> – Rutas guiadas para identificar especies nativas, analizar y entender el medio local.</li>
      <li>
        <img src="/imagenes/iconos/color/manos.png" alt="Icono colaboración — networking" title="Networking ambiental" class="icono" loading="lazy" />
        <strong>Networking Ambiental</strong> – Encuentros entre participantes, expertos y asociaciones para generar alianzas verdes.</li>
      <li>
        <img src="/imagenes/iconos/color/graficos.png" alt="Icono seguimiento — evolución" title="Seguimiento y evolución" class="icono" loading="lazy" />
        <strong>Seguimiento y Evolución</strong> – Evaluación y seguimiento del impacto durante el proyecto.</li>
    </ul>

    <h3>¿A quién va dirigido?</h3>
    <ul>
      <li>
        <img src="/imagenes/iconos/color/familia.png" alt="Familia" class="icono" loading="lazy" />
        <strong>Familias</strong> – Actividades didácticas para niños y adultos.</li>
      <li>
        <img src="/imagenes/iconos/color/cole.png" alt="Colegio" class="icono" loading="lazy" />
        <strong>Colegios y otros centros de estudio</strong> – Proyectos educativos de concienciación ecológica.</li>
      <li>
        <img src="/imagenes/iconos/color/empresa.png" alt="Empresa" class="icono" loading="lazy" />
        <strong>Empresas</strong> – Team buildings con impacto ambiental positivo.</li>
      <li>
        <img src="/imagenes/iconos/color/ayuntamiento.png" alt="Ayuntamiento" class="icono" loading="lazy" />
        <strong>Ayuntamientos y asociaciones</strong> – Planes de biorregeneración urbana y participación ciudadana.</li>
    </ul>

    <h3>¿Por qué Zalla Natura?</h3>
    <p>        
      <img src="/imagenes/iconos/color/adaptable.png" alt="Icono adaptable — proyecto adaptable" title="Proyecto adaptable" class="icono" loading="lazy" />
      <strong>Proyecto adaptable</strong> – Puede implementarse en parques, riberas, zonas urbanas o rurales.</p>
    <p>        
      <img src="/imagenes/iconos/color/graficos.png" alt="Evolución" class="icono" loading="lazy" />
      <strong>Metodología probada</strong> – Combinamos ciencia y socidad de manera efectiva.</p>
    <p>
      <img src="/imagenes/iconos/color/planeta.png" alt="Planeta" class="icono" loading="lazy" />
      <strong>Impacto medible</strong> – Seguimiento del proyecto para garantizar su desarrollo.</p>

    <h3>¿Quieres llevar un proyecto de Geobizi Natura a tu municipio o espacio?</h3>
    <p>¡Diseñamos proyectos a medida! Desde un oasis de mariposas hasta un plan de regeneración colaborativa incluyendo los centros escolares y a la ciudadanía. Adaptamos las actividades a tus necesidades.</p>

    <div class="imagen-trio">
      <div>
        <img
          class="img"
          src="/imagenes/proyectos/zallanatura/zallanatura2.avif"
          alt="Zalla Natura — actividades de plantación y biorregeneración"
          title="Zalla Natura — plantación y actividades"
          loading="lazy"
        />
      </div>
      <div>
        <img
          class="img"
          src="/imagenes/proyectos/zallanatura/zallanatura1.avif"
          alt="Zalla Natura — creación de oasis de mariposas"
          title="Zalla Natura — oasis de mariposas"
          loading="lazy"
        />
      </div>
      <div>
        <img
          class="img"
          src="/imagenes/proyectos/zallanatura/zallanatura3.avif"
          alt="Zalla Natura — voluntariado y restauración del hábitat"
          title="Zalla Natura — voluntariado"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'

const pageUrl = 'https://www.geobizi.com/servicios/proyectos'
const ogImage = 'https://www.geobizi.com/imagenes/proyectos/zallanatura/zallanatura2.avif'

useHead({
  title: 'Proyectos Natura — Biorregeneración y participación | GeoBizi',
  meta: [
    { name: 'description', content: 'Proyectos de biorregeneración y participación comunitaria: oasis de mariposas, bombas de semillas, hoteles de insectos y seguimiento del impacto.' },
    { name: 'robots', content: 'index, follow' },
    { name: 'author', content: 'GeoBizi' },
    { name: 'theme-color', content: '#0b8a4c' },
    { name: 'language', content: 'es' },
    { property: 'og:title', content: 'Proyectos Natura — Biorregeneración y participación | GeoBizi' },
    { property: 'og:description', content: 'Iniciativas de biorregeneración y proyectos comunitarios para recuperar biodiversidad y conectar a la ciudadanía con su entorno.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: pageUrl },
    { property: 'og:image', content: ogImage },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:image', content: ogImage }
  ],
  link: [
    { rel: 'canonical', href: pageUrl },
    { rel: 'image_src', href: ogImage },
    { rel: 'apple-touch-icon', href: '/apple-touch-icon.png', sizes: '180x180' }
  ],
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Organization",
            "@id": "https://www.geobizi.com/#organization",
            "name": "GeoBizi",
            "url": "https://www.geobizi.com",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.geobizi.com/imagenes/GeobiziLogo.7ae1d6ce.png",
              "width": 1417,
              "height": 313
            },
            "sameAs": [
              "https://www.facebook.com/geobizirik/",
              "https://www.instagram.com/geotxiki/",
              "https://www.youtube.com/channel/UCw-C_J0y-jKHp7Zx92lsKfg"
            ]
          },
          {
            "@type": "WebPage",
            "url": pageUrl,
            "name": "Proyectos Natura — Biorregeneración y participación | GeoBizi",
            "description": "Iniciativas de biorregeneración y proyectos comunitarios para recuperar biodiversidad y conectar a la ciudadanía con su entorno.",
            "inLanguage": "es",
            "isPartOf": { "@id": "https://www.geobizi.com/#organization" },
            "image": { "@type": "ImageObject", "url": ogImage, "width": 1080, "height": 1080 }
          },
          {
            "@type": "Service",
            "serviceType": "Proyectos de restauración y educación ambiental",
            "provider": { "@type": "Organization", "@id": "https://www.geobizi.com/#organization" },
            "name": "Proyectos Natura — Biorregeneración y participación | GeoBizi",
            "description": "Diseño y ejecución de proyectos de restauración, educación e investigación ambiental.",
            "url": pageUrl,
            "inLanguage": "es",
            "image": { "@type": "ImageObject", "url": ogImage, "width": 1080, "height": 1080 }
          }
        ]
      })
    }
  ]
})
</script>

<style scoped>
  .contenedor-principal {
    padding-top: 7rem;
    background-color: rgb(255, 255, 255);
    padding-bottom: 2rem;
  }
.icono {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>